import { TierRateByYear } from '../../interfaces';

export const rates: TierRateByYear = {
    2020: [
        { to: 200_000, percentage: 16.5 },
        { percentage: 25 },
    ],
    2021: [
        { to: 200_000, percentage: 15 },
        { percentage: 21.7 },
    ],
    2022: [
        { to: 395_000, percentage: 15 },
        { percentage: 25.8 },
    ],
    2023: [
        { to: 200_000, percentage: 19 },
        { percentage: 25.8 },
    ],
    2024: [
        { to: 200_000, percentage: 19 },
        { percentage: 25.8 },
    ]
};
